/* unplugin-vue-components disabled */import { render } from "./dataset-view.vue?vue&type=template&id=02c6ba4c&scoped=true"
import script from "./dataset-view.vue?vue&type=script&lang=js"
export * from "./dataset-view.vue?vue&type=script&lang=js"

import "./dataset-view.vue?vue&type=style&index=0&id=02c6ba4c&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02c6ba4c"],['__file',"src/pages/playground/dataset-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "02c6ba4c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('02c6ba4c', __exports__)) {
    api.reload('02c6ba4c', __exports__)
  }
  
  module.hot.accept("./dataset-view.vue?vue&type=template&id=02c6ba4c&scoped=true", () => {
    api.rerender('02c6ba4c', render)
  })

}


export default __exports__